import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, Subject, tap } from 'rxjs';
import { EnvService } from 'src/app/env.service';
import { ContentService } from '../../content/content.service';

function getXauth() {
  let loginData = JSON.parse(localStorage.getItem('loginData')) || {};
  let xAuth = loginData.token;
  return xAuth;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    //  'x-auth': getXauth()
  }),
};

@Injectable({
  providedIn: 'root',
})
export class CourseCreatorService {
  private courseSource = new Subject<any>();
  private courseListSource = new Subject<any>();
  private currentSectionSource = new Subject<any>();

  course$ = this.courseSource.asObservable();
  courseList$ = this.courseListSource.asObservable();
  currentSection$ = this.currentSectionSource.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly env: EnvService,
    private readonly contentService: ContentService
  ) {}

  deleteCourse(id): Observable<any> {
    return this.http.post(this.env.apiUrl + 'course/delete/?id=' + id, httpOptions);
  }
  deleteBlogPost(id): Observable<any> {
    return this.http.delete(this.env.apiUrl + 'blog/delete/?id=' + id, httpOptions);
  }
  deleteSection(data): Observable<any> {
    return this.http.post(this.env.apiUrl + 'course/delete-section/', data, httpOptions).pipe(
      tap(() => {
        this.contentService.getTheCourse(data.courseID).subscribe(); // Refresh the course data in the cache
      }),
      catchError((error) => {
        console.error('Error deleting section:', error);
        return of(null);
      })
    );
  }

  deleteLecture(data): Observable<any> {
    return this.http.post(this.env.apiUrl + 'course/delete-lecture/', data, httpOptions).pipe(
      tap(() => {
        this.contentService.getTheCourse(data.courseID).subscribe(); // Refresh the course data in the cache
      }),
      catchError((error) => {
        console.error('Error deleting lecture:', error);
        return of(null);
      })
    );
  }

  setCourse(course) {
    this.courseSource.next(course);
  }
  setCourseList(list) {
    this.courseListSource.next(list);
  }
  setCurrentSection(currentSection) {
    this.currentSectionSource.next(currentSection);
  }
}
